import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useLocateMyDeviceEnabled = (iotDevice) => {
    const isGlobalDeviceAlarm = iotDeviceGlobalConfigService.isGlobalDeviceAlarm(iotDevice);
    const isAlarmEnabled = iotDeviceFeatureConfigService.isDeviceAlarmEnabled();
    const isEnabled = iotDeviceSettingsService.isSettingAvailable(iotDevice, isGlobalDeviceAlarm, isAlarmEnabled);

    return isEnabled;
};

export default useLocateMyDeviceEnabled;
